import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "mbh-main" };
const _hoisted_2 = ["href"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    key: 0,
    class: "mbh-inputField"
};
const _hoisted_5 = ["id"];
const _hoisted_6 = ["aria-controls", "aria-owns", "aria-checked", "aria-label", "onClick"];
const _hoisted_7 = { class: "this-title" };
const _hoisted_8 = ["id", "aria-labelledby"];
const _hoisted_9 = { class: "mbh-menuDropdown-inner" };
const _hoisted_10 = { class: "mbh-loginWrapper" };
import { ThemeIcon, ThemeButton } from '../../../front/components';
import { ref, watch, nextTick } from 'vue';
import Cell from './Cell.vue';
import { theme } from '../../../front/Theme';
import SiteSearch from '../../../front/components/SiteSearch/SiteSearch.vue';
import { freezeWindowScroll, unfreezeWindowScroll } from '../../../front/shared';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MobileHeader',
    props: {
        siteHeader: {}
    },
    emits: {
        showLogin: null,
    },
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const json = props.siteHeader.json;
        const menu = json.menu;
        const searchWrapperEl = ref(null);
        const menuActive = ref(false);
        const activeMenuItem = ref(null);
        const searchActive = ref(false);
        const searchQuery = ref('');
        const searchQueryInputEl = ref(null);
        const emit = __emit;
        __expose({
            canDuck,
        });
        watch(searchActive, value => {
            if (!value) {
                return;
            }
            nextTick(() => {
                var _a;
                const inputEl = (_a = searchWrapperEl.value) === null || _a === void 0 ? void 0 : _a.querySelector('input.siteSearch-inputField-input');
                inputEl === null || inputEl === void 0 ? void 0 : inputEl.focus();
            });
        });
        function emptySearchQuery(searchInputEl) {
            searchQuery.value = '';
            searchInputEl === null || searchInputEl === void 0 ? void 0 : searchInputEl.focus();
        }
        function toggleMenu() {
            return menuActive.value ? hideMenu() : showMenu();
        }
        function hideMenu() {
            hideActiveMenuItem();
            menuActive.value = false;
            unfreezeWindowScroll();
        }
        function showMenu() {
            hideSearch();
            menuActive.value = true;
            freezeWindowScroll();
        }
        function isMenuItemActive(menuItem) {
            var _a;
            return ((_a = activeMenuItem.value) === null || _a === void 0 ? void 0 : _a.entry.id) === menuItem.entry.id;
        }
        function toggleMenuItem(menuItem) {
            return isMenuItemActive(menuItem) ? hideActiveMenuItem() : showMenuItem(menuItem);
        }
        function showMenuItem(menuItem) {
            var _a;
            if (!menuActive.value) {
                showMenu();
            }
            if (((_a = activeMenuItem.value) === null || _a === void 0 ? void 0 : _a.entry.id) === menuItem.entry.id) {
                return;
            }
            hideSearch();
            activeMenuItem.value = menuItem;
        }
        function hideActiveMenuItem() {
            if (!activeMenuItem.value) {
                return;
            }
            activeMenuItem.value = null;
        }
        function hideSearch() {
            searchActive.value = false;
            unfreezeWindowScroll();
        }
        function showSearch() {
            hideMenu();
            searchActive.value = true;
            nextTick(() => { var _a; return (_a = searchQueryInputEl.value) === null || _a === void 0 ? void 0 : _a.focus(); });
            freezeWindowScroll();
        }
        function toggleSearch() {
            return searchActive.value ? hideSearch() : showSearch();
        }
        function canDuck() {
            return !menuActive.value && !searchActive.value && !activeMenuItem.value;
        }
        function onMenuDropdownEnter(el) {
            window.requestAnimationFrame(() => {
                const innerEl = el.querySelector('.mbh-menuDropdown-inner');
                innerEl.style.height = innerEl.scrollHeight + 'px';
            });
        }
        function onMenuDropdownLeave(el) {
            const innerEl = el.querySelector('.mbh-menuDropdown-inner');
            innerEl.style.height = '0';
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("a", {
                        class: "mbh-logo",
                        href: _unref(json).homeUrl,
                        "aria-label": "Skolporten hemsida"
                    }, [
                        _createElementVNode("img", {
                            src: _unref(theme)().getUri('assets/images/skolporten-logo-primary.svg'),
                            alt: "Skolporten logo"
                        }, null, 8, _hoisted_3)
                    ], 8, _hoisted_2),
                    _createVNode(_Transition, { name: "reveal" }, {
                        default: _withCtx(() => [
                            (searchActive.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "mbh-inputField-input",
                                        type: "text",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                                        ref_key: "searchQueryInputEl",
                                        ref: searchQueryInputEl
                                    }, null, 512), [
                                        [_vModelText, searchQuery.value]
                                    ]),
                                    _createVNode(_unref(ThemeIcon), {
                                        class: "mbh-inputField-icon",
                                        name: "magnifying-glass"
                                    }),
                                    (searchQuery.value)
                                        ? (_openBlock(), _createBlock(_unref(ThemeButton), {
                                            key: 0,
                                            class: "mbh-inputField-emptyBtn",
                                            "wca-title": "Empty search",
                                            icon: "times-round-outline",
                                            color: "primary",
                                            fill: "none",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (emptySearchQuery()))
                                        }))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }),
                    _createElementVNode("button", {
                        class: _normalizeClass(["mbh-topAction action--search", { 'is--active': searchActive.value }]),
                        title: "Sök Skolporten",
                        onClick: _cache[2] || (_cache[2] = ($event) => (toggleSearch()))
                    }, [
                        _createVNode(_Transition, { name: "swap" }, {
                            default: _withCtx(() => [
                                (searchActive.value)
                                    ? (_openBlock(), _createBlock(_unref(ThemeIcon), {
                                        key: 0,
                                        name: "times"
                                    }))
                                    : (_openBlock(), _createBlock(_unref(ThemeIcon), {
                                        key: 1,
                                        name: "magnifying-glass"
                                    }))
                            ]),
                            _: 1
                        })
                    ], 2),
                    _createElementVNode("button", {
                        class: _normalizeClass(["mbh-topAction action--menu", { 'is--active': menuActive.value }]),
                        title: "Visa/dölj huvudmenyn",
                        onClick: _cache[3] || (_cache[3] = ($event) => (toggleMenu()))
                    }, [
                        _createVNode(_Transition, { name: "swap" }, {
                            default: _withCtx(() => [
                                (menuActive.value)
                                    ? (_openBlock(), _createBlock(_unref(ThemeIcon), {
                                        key: 0,
                                        name: "times"
                                    }))
                                    : (_openBlock(), _createBlock(_unref(ThemeIcon), {
                                        key: 1,
                                        name: "menu"
                                    }))
                            ]),
                            _: 1
                        })
                    ], 2)
                ]),
                _createVNode(_Transition, { name: "reveal" }, {
                    default: _withCtx(() => [
                        (searchActive.value || menuActive.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["mbh-bottom", { 'with--menu': menuActive.value, 'with--search': searchActive.value }])
                            }, [
                                (menuActive.value)
                                    ? (_openBlock(), _createElementBlock("nav", {
                                        key: 0,
                                        class: _normalizeClass(["mbh-menu", { 'has--active': activeMenuItem.value }])
                                    }, [
                                        _createElementVNode("ul", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (menuItem) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    key: _ctx.siteHeader.makeId(`menuitem-${menuItem.entry.id}`),
                                                    id: _ctx.siteHeader.makeId(`menuitem-${menuItem.entry.id}`),
                                                    class: _normalizeClass(["mbh-menuItem", {
                                                            'is--active': isMenuItemActive(menuItem),
                                                            [`is--${menuItem.entry.locationRelation}`]: menuItem.entry.locationRelation
                                                        }])
                                                }, [
                                                    _createVNode(_Transition, { name: "reveal" }, {
                                                        default: _withCtx(() => [
                                                            (!activeMenuItem.value || activeMenuItem.value.entry.id === menuItem.entry.id)
                                                                ? (_openBlock(), _createElementBlock("button", {
                                                                    key: 0,
                                                                    type: "button",
                                                                    class: _normalizeClass(["mbh-menuTopEntry", { 'is--active': isMenuItemActive(menuItem) }]),
                                                                    "aria-controls": _ctx.siteHeader.makeId(`drop-${menuItem.entry.id}`),
                                                                    "aria-owns": _ctx.siteHeader.makeId(`drop-${menuItem.entry.id}`),
                                                                    "aria-checked": isMenuItemActive(menuItem),
                                                                    "aria-haspopup": "true",
                                                                    "aria-label": menuItem.entry.title,
                                                                    ref_for: true,
                                                                    ref: "menuItemButtons",
                                                                    onClick: ($event) => (toggleMenuItem(menuItem))
                                                                }, [
                                                                    _createVNode(_unref(ThemeIcon), {
                                                                        class: "this-arrowLeft",
                                                                        name: "arrow-left-long"
                                                                    }),
                                                                    _createElementVNode("span", _hoisted_7, _toDisplayString(menuItem.entry.title), 1),
                                                                    _createVNode(_unref(ThemeIcon), {
                                                                        class: "this-arrowRight",
                                                                        name: "arrow-right-long"
                                                                    })
                                                                ], 10, _hoisted_6))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_Transition, {
                                                        name: "reveal",
                                                        onEnter: onMenuDropdownEnter,
                                                        onLeave: onMenuDropdownLeave
                                                    }, {
                                                        default: _withCtx(() => [
                                                            (activeMenuItem.value && activeMenuItem.value.entry.id === menuItem.entry.id)
                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                    key: menuItem.entry.id,
                                                                    id: _ctx.siteHeader.makeId(`drop-${menuItem.entry.id}`),
                                                                    class: "mbh-menuDropdown",
                                                                    "aria-labelledby": _ctx.siteHeader.makeId(`menuItem-${menuItem.entry.id}`)
                                                                }, [
                                                                    _createElementVNode("div", _hoisted_9, [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeMenuItem.value.cells, (cell, cidx) => {
                                                                            return (_openBlock(), _createBlock(Cell, {
                                                                                key: activeMenuItem.value.entry.id.toString() + cidx,
                                                                                cell: cell
                                                                            }, null, 8, ["cell"]));
                                                                        }), 128))
                                                                    ])
                                                                ], 8, _hoisted_8))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ], 10, _hoisted_5));
                                            }), 128)),
                                            _createElementVNode("li", _hoisted_10, [
                                                _createVNode(_unref(ThemeButton), {
                                                    title: "Logga in",
                                                    icon: "login",
                                                    color: "dark",
                                                    fill: "outline",
                                                    onClick: _cache[4] || (_cache[4] = ($event) => (emit('showLogin')))
                                                })
                                            ])
                                        ])
                                    ], 2))
                                    : (searchActive.value)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: "mbh-search",
                                            ref_key: "searchWrapperEl",
                                            ref: searchWrapperEl
                                        }, [
                                            _createVNode(SiteSearch, {
                                                query: searchQuery.value,
                                                "link-to-search-page": true,
                                                "without-input": true
                                            }, null, 8, ["query"])
                                        ], 512))
                                        : _createCommentVNode("", true)
                            ], 2))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
